export const formatZipCode = (zipCode: string) => {
    if (!zipCode) {
        return "";
    }
    const newZipCode = zipCode.replace(/[^\d]/g, "");
    const newZipCodeLength = newZipCode.length;

    if (newZipCodeLength < 5) {
        return newZipCode;
    }
    if (newZipCodeLength < 6) {
        return `${newZipCode.slice(0, 5)}`;
    }
    if (newZipCodeLength < 9) {
        return `${newZipCode.slice(0, 5)}-${newZipCode.slice(5, 9)}`;
    }
    return `${newZipCode.slice(0, 5)}-${newZipCode.slice(5, 9)}`;
};